<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Client API Response
      </div>
    </div>
    <v-divider class="mt-1 mr-8 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="clients"
      :loading="loader"
      class="elevation-1 custom-icon-size mr-8"
      :options.sync="options"
      disable-pagination
      hide-default-footer
    >
    </v-data-table>
    <Summary />
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import Summary from "@/views/front/ClientApiSummary.vue";
export default {
  components: { Summary },
  computed: {},
  data: () => ({
    options: {},
    headers: [
      {
        text: "Storer Name",
        value: "client_name",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },

      {
        text: "Success Count",
        value: "success_count",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Failed Count",
        value: "failed_count",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Pending Transactions Count(Since more than 1 hour)",
        value: "pending_count",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Stuck Correction Count(Since more than 15mins)",
        value: "stuck_correction_count",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Stuck Putaway Count(Since more than 15mins)",
        value: "stuck_putaway_count",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Stuck Receiving Count(Since more than 15mins)",
        value: "stuck_receiving_count",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    clients: [],
    loader: false,
  }),

  created() {},
  watch: {
    options: {
      handler() {
        this.fetchClientAPiResponse();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["getClientApiTracking"]),

    fetchClientAPiResponse() {
      this.loader = true;
      this.getClientApiTracking()
        .then((res) => {
          this.loader = false;
          const result = Object.keys(res.data).map((client_name) => {
            return {
              client_name,
              pending_count: res.data[client_name].pending_count,
              failed_count: res.data[client_name].failed_count,
              success_count: res.data[client_name].success_count,
              stuck_correction_count:
                res.data[client_name].stuck_correction_count,
              stuck_putaway_count: res.data[client_name].stuck_putaway_count,
              stuck_receiving_count:
                res.data[client_name].stuck_receiving_count,
            };
          });
          this.clients = result;
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>
